export const legalUrls = [
  {
    label: {
      en: 'Cookie Policy',
      it: 'Cookie Policy',
      fr: 'Cookie Policy',
      ja: 'Cookie Policy',
      zh: 'Cookie Policy'
    },
    url: {
      en: '/cookie-policy/index.html',
      it: '/cookie-policy/index.html',
      fr: '/cookie-policy/index.html',
      ja: '/cookie-policy/index.html',
      zh: '/cookie-policy/index.html'
    }
  },
  {
    label: {
      en: 'Privacy Policy',
      it: 'Privacy Policy',
      fr: 'Privacy Policy',
      ja: 'Privacy Policy',
      zh: 'Privacy Policy'
    },
    url: {
      en: 'https://www.gucci.com/documents/legal/privacy/en.pdf',
      it: 'https://www.gucci.com/documents/legal/privacy/it.pdf',
      fr: 'https://www.gucci.com/documents/legal/privacy/fr.pdf',
      ja: 'https://www.gucci.com/documents/legal/privacy/jp.pdf',
      zh: 'https://www.gucci.com/documents/legal/privacy/en.pdf'
    }
  },
  {
    label: {
      en: 'Terms and conditions',
      it: 'Terms and conditions',
      fr: 'Terms and conditions',
      ja: 'Terms and conditions',
      zh: 'Terms and conditions'
    },
    url: {
      en: 'https://www.gucci.com/uk/en_gb/st/privacy-landing',
      it: 'https://www.gucci.com/it/it/st/privacy-landing',
      fr: 'https://www.gucci.com/fr/fr/st/privacy-landing',
      ja: 'https://www.gucci.com/jp/ja/st/privacy-landing',
      zh: 'https://www.gucci.com/hk/zh/st/privacy-landing'
    }
  }
]
